<div class="area-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/updater.svg">
            <span class="title">Auto Updater</span>
        </div>
        <div class="page-actions">
            <button mat-button color="primary" class="btn-add" (click)="addClicked()"><mat-icon>person_add</mat-icon>Add
                New Version</button>

            <!-- <button mat-button color="accent" class="btn-export" (click)="exportClicked()" [disabled]="IsDownloading">
                <img class="download-icon"
                    [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                Export
            </button> -->
        </div>
    </div>
    <div class="data-container ">
        <app-loader [show]="isLoading"></app-loader>

        <!--<app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                        [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                        [hidePageSize]="true">
            </app-search-filter> -->
        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)">
                <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef class="item-header">#</th>
                    <td mat-cell *matCellDef="let version; let i = index" class="item-column">{{
                        (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                </ng-container>

                <ng-container matColumnDef="version">
                    <th mat-sort-header="version" mat-header-cell *matHeaderCellDef>Version</th>
                    <td mat-cell *matCellDef="let version">
                        <!-- <span class="version-number">{{version.version}}</span> -->
                        <button mat-button color="primary" class="btn-view-shops"
                            (click)="onAssignedShop(version); $event.stopPropagation();">
                            {{version.version}}
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="folder">
                    <th mat-sort-header="folder" mat-header-cell *matHeaderCellDef>Folder</th>
                    <td mat-cell *matCellDef="let version">
                        <span class="folder-name">{{version.folder}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="critical">
                    <th mat-sort-header="critical" mat-header-cell *matHeaderCellDef>Critical</th>
                    <td mat-cell *matCellDef="let version">
                        <span class="critical-status"
                            [ngClass]="{'critical-yes': version.critical, 'critical-no': !version.critical}">
                            {{version.critical ? 'Yes' : 'No'}}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="assignShops">
                    <th mat-sort-header="assignShops" mat-header-cell *matHeaderCellDef>Assign Shops</th>
                    <td mat-cell *matCellDef="let version">
                        <!-- <span class="shop-count" [ngClass]="{'no-shops': version.assignedShops === 0}">
                            {{version.assignedShops || 0}}
                        </span> -->
                        <button mat-button color="primary" class="btn-view-shops"
                            (click)="onShopsUpdate(version); $event.stopPropagation();">
                            {{version.assignedShops || 0}}
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="edit">
                    <th mat-header-cell *matHeaderCellDef>Edit</th>
                    <td mat-cell *matCellDef="let version">
                        <button mat-button color="primary" class="btn-view-shops"
                            (click)="onViewShops(version); $event.stopPropagation();">
                            <mat-icon>store</mat-icon>
                            View Shop & Terminals
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                        <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                            (click)="onRowSelected(rowItem);$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>

                        <mat-menu #rowMenu>
                            <button mat-menu-item (click)="onEdit(rowItem)">
                                <mat-icon>edit</mat-icon>
                                Edit Version
                            </button>
                            <button mat-menu-item (click)="onDeploy(rowItem)">
                                <mat-icon>cloud_upload</mat-icon>
                                Deploy
                            </button>
                            <button mat-menu-item (click)="onDelete(rowItem)" class="delete-action">
                                <mat-icon>delete</mat-icon>
                                Delete
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                </tr>
                <tr mat-row class="table-element-row" *matRowDef="let version; columns: displayedColumns;"
                    (click)="onRowSelected(version)" (dblclick)="onEdit(version)"
                    [ngClass]=" {'row-selected' : version.id===selectedItem?.id}">
                </tr>
            </table>
        </section>

        <!-- </ng-container> -->
        <!-- <ng-template #nodata> -->
        @if(pagingData.length<=0){ <div class="no-data-container">
            <img src="assets/images/no-data.png">
            <span class="no-data-info">No data found. Please remove or redefine the filters if
                any.</span>
    </div>
    <!-- </ng-template> -->
    }
</div>

</div>